import React, { useEffect, useRef, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { useNavigate } from 'react-router-dom'
import { CForm, CFormLabel, CFormInput, CButton, CCol, CImage, CInputGroup, CFormTextarea, CModal, CModalBody, CModalFooter } from '@coreui/react'
import AsyncSelect from 'react-select/async'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import MyToastify from 'src/components/myComponents/MyToactify'
import css from './WorkersForm.module.scss'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { MdOutlineAddAPhoto } from 'react-icons/md'
import { BsFillPersonFill } from 'react-icons/bs'
import WorkerModal from './WorkerModal'
import dayjs from 'dayjs';
import WorkerModalV1 from './WorkerModalV1'


const urlApi = '/workers'
const urlApi_2 = '/account_workers'
const urlRouter = '/workers'
const urlRouterUpdate = '/workers/update'
const urlMedia = '/media_objects'
const docsUrl = '/worker_proffesion_docs';

// токен
const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }
const role = localStorage.getItem('user_role')
// id користувача
const userData = JSON.parse(localStorage.getItem('user_data'))
console.log('userData', userData);
// console.log('role', role)

export async function LoaderWorkersUpdate({ params }) {
  const id = params.pid

  if (Object.keys(params).length !== 0) {
    try {
      const response1 = await AxiosInstance.get(`${urlApi}/${id}`, header)


      // const response2 = await AxiosInstance.get(
      //   `${urlApi_2}?worker.id=${response1.data.id}`,
      //   header,
      // )

      const accountWorkerQuery = role === 'ROLE_ADMIN'
        ? `${urlApi_2}?worker.id=${response1.data.id}`
        : `${urlApi_2}?worker.id=${response1.data.id}&account.user.id=${userData.id}`

      const response2 = await AxiosInstance.get(accountWorkerQuery, header)



      return { data: response1.data, data2: response2.data }
    } catch (error) {
      console.error('Помилка під час виконання запитів', error)
      return null
    }
  }

  return null
}

//масив робіт 
// const listOfJobs =
//   [
//     {
//       "id": 1,
//       "name": "Зварювальник",
//       "date_entered": "2025-10-20T11:10:47.388Z",
//       "created_by": 101,
//       "description": "Професія, що займається зварюванням металів.",
//       "status": "active",
//       "type": "manual",
//       // "workerProfessions": ["Зварювальник"]
//     },
//     {
//       "id": 2,
//       "name": "Стропальник",
//       "date_entered": "2025-10-20T11:12:00.000Z",
//       "created_by": 102,
//       "description": "Професія, що займається підйомом вантажів.",
//       "status": "active",
//       "type": "manual",
//       // "workerProfessions": ["Стропальник"]
//     },
//     {
//       "id": 3,
//       "name": "Електрик",
//       "date_entered": "2025-10-20T11:15:30.000Z",
//       "created_by": 103,
//       "description": "Професія, що займається електромонтажними роботами.",
//       "status": "active",
//       "type": "manual",
//       // "workerProfessions": ["Електрик"]
//     }
//   ]

const workerList = [{ id: 0, proffesion: { id: 1, name: "Зварювальник" } },
{ id: 1, proffesion: { id: 3, name: "Електрик" } }]

const WorkersForm = () => {
  const navigate = useNavigate()
  // дані для оновлення перші

  const { data, data2 } = useLoaderData() || {}
  // console.log('data', data)
  // console.log('дані контрагента', data2)

  // const [selectedOption, setSelectedOption] = useState(data2 && data2.length > 0 ? { label: data2[0].account.name, id: data2[0].account.id } : null)
  // const [selectedOption, setSelectedOption] = useState(
  //   data2 && data2.length > 0 ? { label: data2[0].account.name, id: data2[0].account.id } : null,
  // )
  //1.зміна розкоментувати и закоментувати верх ,коли буде додано поле main в accountWorkers(це з використанням поля main,нов закоментовано)
  // const [selectedOption, setSelectedOption] = useState(
  //   data2 && data2.length > 0
  //     ? (() => {
  //       const main = data2.find(el => el.main === true) || data2[0]
  //       return { label: main.account.name, value: main.account.id, id: main.account.id }
  //     })()
  //     : null
  // )
  //кінець зміни 1

  //1.зміна після додавання поля mainForUsers
  const [selectedOption, setSelectedOption] = useState(
    data2 && data2.length > 0
      ? (() => {
        const main = data2.find(el => el.mainForUsers?.includes(userData.id)) || data2[0]
        return { label: main.account.name, value: main.account.id, id: main.account.id }
      })()
      : null
  )
  //1.зміна

  const [file, setFile] = useState(null)
  const [photo, setPhoto] = useState(null)
  // const [showAddWorkers, setShowAddWorkers] = useState(false)
  const [ipn, setIpn] = useState(data ? data.codeIpn : '')
  // const [arrFile, setArrFile] = useState(data2 ? [...data2[0]?.media] : [])

  //2.зміна розкоментувати и закоментувати верх ,коли буде додано поле main в accountWorkers(зміна закоментована)
  // const [arrFile, setArrFile] = useState(() => {
  //   if (!data2 || data2.length === 0) return []
  //   const main = data2.find(el => el.main === true) || data2[0]
  //   return [...(main?.media || [])]
  // })
  //2.кінець зміни 

  //2.зміна версія для  використання після додавання поля mainForUsers
  const [arrFile, setArrFile] = useState(() => {
    if (!data2 || data2.length === 0) return []
    const main = data2.find(el => el.mainForUsers?.includes(userData.id)) || data2[0]
    return [...(main?.media || [])]
  })
  //2 зміна

  const [combinedSeries, setCombinedSeries] = useState({ series: '', number: '' })
  const [combinedDate, setCombinedDate] = useState({ day: '00', month: '00', year: '1900' })
  const [dateOfBirthWorker, setDateOfBirthWorker] = useState('')
  const [dataState, setDataState] = useState(data)
  const [savedDataState, setSavedDataState] = useState(data)
  const [showVerifyHelpModal, setShowVerifyHelpModal] = useState(false)
  const [workerId, setWorkerId] = useState(data?.id != undefined ? data.id : '')
  const [workerPhoto, setWorkerPhoto] = useState('')
  // Для видалення старого фото після завантаження нового
  const [deleteOldPhotoId, setdeleteOldPhotoId] = useState(
    data?.photo?.id != undefined ? data.photo.id : '',
  )
  const [inputValue, setInputValue] = useState('')

  //стани блоку професій
  const [blocks, setBlocks] = useState([0]);
  //стан відкриття попапу посвідчення
  const [showPopup, setShowPopup] = useState(false);

  const [workerProfessions, setWorkerProfessions] = useState(
    // workerList
    []
  )
  //список працівників
  const [jobList, setJobList] = useState([])
  //вибрана робота
  const [selectedJob, setSelectedJob] = useState(null);

  const [coment, setComent] = useState({})
  //стан для зберігання файлу по професіям 
  const [filesByProfession, setFilesByProfession] = useState({});
  const fileInputs = useRef({});







  const addNewBlock = () => {
    setBlocks([...blocks, blocks.length]);
  };

  // Після створення працівника взяти його id для додавання зображення (аватара)
  useEffect(() => {
    if (data !== undefined && data?.id !== undefined) {
      // console.log('data', data);
      setWorkerId(data.id)
    }
  }, [data])

  // useEffect(() => {
  //   console.log('dataState', dataState)
  // }, [dataState])

  useEffect(() => {
    const { year, month, day } = combinedDate

    // Перевірка чи на цифри
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      const formattedDate = new Date(Number(year), Number(month) - 1, Number(day) + 1).toISOString()
      setDateOfBirthWorker(formattedDate)
    } else {
      console.error('Invalid date format:', combinedDate)
    }
  }, [combinedDate])

  // Для відслідковування зміни вхідних даних і відображення коректного фото працівника
  useEffect(() => {
    // console.log('dataState', dataState)
    // console.log('workerPhoto', workerPhoto);
    // Заповнити фото працівника
    if (dataState?.photo?.contentUrl) {
      setWorkerPhoto(dataState?.photo?.contentUrl)
    }

    // Заповнити іd працівника
    if (dataState != undefined) {
      setWorkerId(dataState.id)
    }
  }, [dataState])

  const parseDateString = (dateString) => {
    const date = new Date(dateString)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear().toString()

    return { day, month, year }
  }

  useEffect(() => {
    if (data?.dateOfBirth) {
      const parsedDate = parseDateString(data.dateOfBirth)
      setCombinedDate(parsedDate)
    }
  }, [])

  const parseSeriesString = (seriesString) => {
    const [series, number] = seriesString.split(' ')
    return { series, number }
  }

  useEffect(() => {
    if (data?.seriaPasport) {
      const parsedSeries = parseSeriesString(data.seriaPasport)
      setCombinedSeries(parsedSeries)
    }
  }, [])

  // Викликає popup з власного компонента
  const popup = MyToastify()
  // Текст для popup
  const popupTextPostSuccess = 'Працівника створено'
  const popupTextWorkerSuccess = 'Працівника додано'
  const popupTextPutSuccess = 'Працівника оновлено'
  const popupTextDeleteSuccess = 'Файл видалено'
  const popupTextAddInput = 'Виберіть контрагента'
  const popupTextNotAdd = 'Цей контрагент уже присвоєний'
  // поточна дата
  const currentDate = new Date()

  const handleSubmit = (event) => {
    console.log('відправляю дані форми')
    event.preventDefault()

    if (!selectedOption) {
      popup.toastifyWarning(popupTextAddInput)
      return
    }

    // дані для оновлення працівника
    const data_response_1 = {
      codeIpn: dataState.codeIpn,
      fullName: dataState.fullName,
      description: dataState.description,
      phone: dataState.phone,
      position: dataState.position,
      dateOfBirth: dateOfBirthWorker,
      seriaPasport: `${combinedSeries.series} ${combinedSeries.number}`,
      dateEntered: currentDate.toISOString(),
      status: 'changed',
    }

    // дані для створення працівника
    const data_response_3 = {
      codeIpn: dataState.codeIpn,
      fullName: dataState.fullName,
      description: dataState.description,
      phone: dataState.phone,
      position: dataState.position,
      dateOfBirth: dateOfBirthWorker,
      seriaPasport: `${combinedSeries.series} ${combinedSeries.number}`,
      dateEntered: currentDate.toISOString(),
      status: 'new',
    }

    // console.log("dataState", dataState);

    // якщо працівник є оновлюємо
    if (data) {
      // Оновити дані працівника
      console.log('є дані пуск 1')
      // console.log('data_response_1', data_response_1);
      const response = AxiosInstance.put(`${urlApi}/${data.id}`, data_response_1, header).then(
        (response) => {
          if (response.status === 200) {
            // Popup про успішні зміни
            popup.toastifySuccess(popupTextPutSuccess)
            setSavedDataState(response.data)
            // return navigate(urlRouter)
            // return navigate(`${urlRouterUpdate}/${response.data.id}`)
          }
        },
      )
    }

    // else if (dataState.id) {

    // якщо працівник вже є то створи звязок для нього
    if (dataState.id) {
      console.log('dataState є дані пуск 2', dataState)

      const data_response_2 = {
        account: `/api/accounts/${selectedOption.value}`, //ід контрагента   це звязок
        worker: {
          id: dataState.id, //дані працівника
          codeIpn: dataState.codeIpn,
          fullName: dataState.fullName,
          dateEntered: dataState.dateEntered,
          description: dataState.description,
          phone: dataState.phone,
          status: dataState?.status ? dataState.status : 'changed',
        },
      }

      // перевірка тут

      // 1 перевірка чи має вже акаунт цього працівника у звязку акунт_воркер ==== dataState.id,
      // 2 якщо має то пропусти
      // 3 якщо нема то створи звязок
      //прибираю для того щоб видаляти акаунт воркера і потім додавати в масив нового

      // AxiosInstance.get(`${urlApi_2}?worker.id=${dataState.id}`, header).then((response) => {
      //   console.log('response', response.data)

      //   const hasReletionship = response.data.some((el) => el.account.id === selectedOption.value)

      //   if (hasReletionship) {
      //     console.log('є у цього контрагента')
      //     return
      //   } else {
      //     console.log('немає у цього контрагента')
      //     // створення звязку
      //     AxiosInstance.post(`${urlApi_2}`, data_response_2, header).then((response) => { })
      //   }
      // })

      // // Popup про успішні зміни
      // popup.toastifyWarning(popupTextNotAdd)

      // return navigate(`${urlRouterUpdate}/${dataState.id}`)


      //тут нова версія з додаванням поля main =true обраному акаунт воркеру,і додавання main=false або null акаунт воркерам якы мали мейн тру 
      //3.зміна  розкоментувати и закоментувати верх ,коли буде додано поле main в accountWorkers(зараз закоментовано)
      // AxiosInstance.get(`${urlApi_2}?worker.id=${dataState.id}`, header).then((response) => {
      //   const allRelations = response.data
      //   const currentMain = allRelations.find(el => el.main === true)
      //   const selectedRelation = allRelations.find(el => el.account.id === selectedOption.value)

      //   if (selectedRelation) {
      //     const patches = []
      //     if (currentMain && currentMain.id !== selectedRelation.id) {
      //       patches.push(AxiosInstance.patch(`${urlApi_2}/${currentMain.id}`, { main: false }, header))
      //     }
      //     patches.push(AxiosInstance.patch(`${urlApi_2}/${selectedRelation.id}`, { main: true }, header))

      //     Promise.all(patches).then(() => {
      //       navigate(`${urlRouterUpdate}/${dataState.id}`)
      //     })
      //   } else {
      //     const patches = []
      //     if (currentMain) {
      //       patches.push(AxiosInstance.patch(`${urlApi_2}/${currentMain.id}`, { main: false }, header))
      //     }
      //     Promise.all(patches).then(() => {
      //       AxiosInstance.post(`${urlApi_2}`, { ...data_response_2, main: true }, header).then(() => {
      //         navigate(`${urlRouterUpdate}/${dataState.id}`)
      //       })
      //     })
      //   }
      // })
      //3.зміна

      //3.Зміна 3 після додавання поля mainForUsers
      // адмін — всі account_workers, партнер — тільки свої по user.id
      const awQuery = role === 'ROLE_ADMIN'
        ? `${urlApi_2}?worker.id=${dataState.id}`
        : `${urlApi_2}?worker.id=${dataState.id}&account.user.id=${userData.id}`

      AxiosInstance.get(awQuery, header).then((response) => {
        const allRelations = response.data
        // account_worker де поточний юзер вже є main
        const currentUserMain = allRelations.find(el => el.mainForUsers?.includes(userData.id))
        // account_worker вибраного контрагента
        const selectedRelation = allRelations.find(el => el.account.id === selectedOption.value)

        if (selectedRelation) {
          // вибраний контрагент вже є в account_workers
          const patches = []
          if (currentUserMain && currentUserMain.id !== selectedRelation.id) {
            // є старий main і він інший — видаляємо userId зі старого
            const updated = (currentUserMain.mainForUsers || []).filter(id => id !== userData.id)
            patches.push(AxiosInstance.patch(`${urlApi_2}/${currentUserMain.id}`, { mainForUsers: updated }, header))
          }
          // додаємо userId до вибраного (без дублів)
          const updatedSelected = [...(selectedRelation.mainForUsers || []).filter(id => id !== userData.id), userData.id]
          patches.push(AxiosInstance.patch(`${urlApi_2}/${selectedRelation.id}`, { mainForUsers: updatedSelected }, header))
          // чекаємо всі PATCH → navigate
          Promise.all(patches).then(async () => {
            //зміна 7 Оновлення медіа післяпатчу для правильного контрагента
            // const fresh = await AxiosInstance.get(`${urlApi_2}?worker.id=${dataState.id}`, header)
            const freshQuery = role === 'ROLE_ADMIN'
              ? `${urlApi_2}?worker.id=${dataState.id}`
              : `${urlApi_2}?worker.id=${dataState.id}&account.user.id=${userData.id}`
            const fresh = await AxiosInstance.get(freshQuery, header)

            const newMain = fresh.data.find(el => el.mainForUsers?.includes(userData.id)) || fresh.data[0]
            setArrFile([...(newMain?.media || [])])
            //зміна 7
            navigate(`${urlRouterUpdate}/${dataState.id}`)
          }
          )
        } else {
          // вибраного контрагента ще немає в account_workers — створюємо новий
          const patches = []
          if (currentUserMain) {
            // є старий main — видаляємо userId з нього
            const updated = (currentUserMain.mainForUsers || []).filter(id => id !== userData.id)
            patches.push(AxiosInstance.patch(`${urlApi_2}/${currentUserMain.id}`, { mainForUsers: updated }, header))
          }
          // чекаємо PATCH → POST новий account_worker з userId в mainForUsers
          Promise.all(patches).then(() => {
            AxiosInstance.post(`${urlApi_2}`, {
              ...data_response_2,
              mainForUsers: [userData.id]
            }, header).then(async () => {
              //зміна 8
              // const fresh = await AxiosInstance.get(`${urlApi_2}?worker.id=${dataState.id}`, header)
              const freshQuery = role === 'ROLE_ADMIN'
                ? `${urlApi_2}?worker.id=${dataState.id}`
                : `${urlApi_2}?worker.id=${dataState.id}&account.user.id=${userData.id}`
              const fresh = await AxiosInstance.get(freshQuery, header)

              const newMain = fresh.data.find(el => el.mainForUsers?.includes(userData.id)) || fresh.data[0]
              setArrFile([...(newMain?.media || [])])
              //зміна 8
              navigate(`${urlRouterUpdate}/${dataState.id}`)
            }
            )
          })
        }
      })
      //3.зміна


      // AxiosInstance.get(`${urlApi_2}?worker.id=${dataState.id}`, header).then((response) => {
      //   const existingRelation = response.data.find((el) => el.account.id === selectedOption.value)

      //   if (existingRelation) {
      //     console.log('existing relation', existingRelation.id)
      //     console.log('existing relation', existingRelation)
      //     AxiosInstance.delete(`${urlApi_2}/${existingRelation.id}`, header).then(() => {
      //       AxiosInstance.post(`${urlApi_2}`, data_response_2, header).then(() => {
      //         navigate(`${urlRouterUpdate}/${dataState.id}`)
      //       })
      //       toast.success("Вже є .Видалено")
      //     })
      //   } else {
      //     AxiosInstance.post(`${urlApi_2}`, data_response_2, header).then(() => {
      //       navigate(`${urlRouterUpdate}/${dataState.id}`)
      //     })
      //   }
      // })




    } else {
      // Створити працівника
      console.log('є дані пуск 3')
      // console.log('data_response_3', data_response_3);
      // якщо працівник відсутній
      const response = AxiosInstance.post(`${urlApi}`, data_response_3, header).then((response) => {
        if (response.status === 201) {
          // ствонення акаунт воркер
          const data_response_2 = {
            account: `/api/accounts/${selectedOption.value}`,
            worker: {
              id: response.data.id,
              codeIpn: response.data.codeIpn,
              fullName: response.data.fullName,
              dateEntered: response.data.dateEntered,
              description: response.data.description,
              phone: response.data.phone,
              status: response.data.status,
            },
          }

          AxiosInstance.post(`${urlApi_2}`,
            //4.зміна  розкоментувати и закоментувати верх ,коли буде додано поле main в accountWorkers
            // { ...data_response_2, main: true }
            //кінець зміни
            // data_response_2
            //4.зміна
            { ...data_response_2, mainForUsers: [userData.id] }
            //4.зміна
            , header).then((response) => { })

          // Popup про успішні зміни
          popup.toastifySuccess(popupTextWorkerSuccess)

          return navigate(`${urlRouterUpdate}/${response.data.id}`)
        }
      })
    }
  }

  // запит зєднати існуючого працівника з підрядником
  const handleSubmitExisting = (event) => {
    event.preventDefault()

    // якщо працівник є
    if (data) {
      console.log('тут є дані їх можна оновити ')
    } else {
      const accountWorkerExisting = {
        account: `/api/accounts/${selectedOption.id}`, //id до кого прикріпити
        worker: `/api/workers/${dataState.id}`,
      }

      AxiosInstance.post(`${urlApi_2}`, accountWorkerExisting, header).then((response) => { })

      // Popup про успішні зміни
      popup.toastifySuccess(popupTextPostSuccess)

      return navigate(urlRouter)
      // return navigate(`${urlRouterUpdate}/${dataState.id}`)
    }
  }

  const loadOptions = async (inputValue) => {
    if (role === 'ROLE_ADMIN') {
      // return await AxiosInstance.get(`/accounts?user.id=${userData.id}`, header).then((response) => {

      // return await AxiosInstance.get(`/accounts`, header).then((response) => {
      // пошук за введеними даними в полі введення
      return await AxiosInstance.get(`/accounts?name=${inputValue}`, header).then((response) => {
        // console.log('response.data', response.data);

        return response.data.map((result) => ({
          label: result.name,
          value: result.id,
        }))
      })
    } else {
      //якщо я зареєстрований але не адмін
      if (userData.id) {
        return await AxiosInstance.get(`/accounts?user.id=${userData.id}`, header).then(
          (response) => {
            // console.log(123131231231, response.data);

            return response.data.map((result) => ({
              label: result.name,
              value: result.id,
            }))
          },
        )
      }
    }
  }

  // при зміні опції
  const handleChangePartner = (select) => {
    setSelectedOption(select)
  }

  // const value = event.target.value;
  // console.log('Введений текст:', value);
  // setInputValue(value);

  // додавання файлів документів
  const handleFileChange = (event) => {
    const myFile = event.target.files[0]

    setFile(myFile)
  }

  //видалення професіі працівника 
  const deleteProffesion = async (id) => {
    try {
      await confirmAlert({
        title: 'Ви впевнені що хочите видалити професію ?',
        message: 'Are you sure to do this.',
        buttons: [
          {
            label: 'Так',
            // onClick: async () => {
            //   // Видалення професіі
            //   await AxiosInstance.delete(`/worker_proffessions/${id}`, header)
            //   // popup.toastifySuccess(popupTextDeleteSuccess)
            //   toast.success('Професію успішно видалено')

            //   // Отримання оновлених даних після видалення файлу
            //   // const response = await AxiosInstance.get(`${urlApi_2}?worker.id=${data.id}`, header)

            //   // setArrFile([...response.data[0].media])
            // },
            onClick: async () => {
              try {
                // Видалення професії
                await AxiosInstance.delete(`/worker_proffessions/${id}`, header)
                // локально видаляємо зі списку
                setWorkerProfessions(prev =>
                  prev.filter(item => item.id !== id)
                )
                toast.success('Професію успішно видалено')
              } catch (error) {
                console.error('Помилка видалення:', error)

                toast.error('Не вдалося видалити професію')
              }
            },

          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    }
  }




  // додавання фото
  const handlePhotoChange = (event) => {
    const selectedPhoto = event.target.files[0];

    // Перевірка, чи обраний файл є файлом у форматі JPEG або PNG
    if (selectedPhoto && (selectedPhoto.type === 'image/jpeg' || selectedPhoto.type === 'image/png')) {
      // Перевірка, чи розмір файлу не перевищує 10 МБ
      if (selectedPhoto.size <= 1024 * 1024 * 10) { // 9 MB
        setPhoto(selectedPhoto);
        // console.log('Фото успішно вибрано:', selectedPhoto);
        popup.toastifySuccess('Фото успішно вибрано:')
      } else {
        // console.log('Розмір файлу перевищує 10 МБ.');
        popup.toastifyWarning('Розмір файлу перевищує 10 МБ.')
      }
    } else {
      // console.log('Оберіть файл у форматі JPEG або PNG.');
      popup.toastifyWarning('Оберіть файл у форматі JPEG або PNG.')
    }
  }

  // відправити файл
  const handleSubmitAddFile = async (e) => {
    e.preventDefault()

    try {
      // Отримати id звязку
      //зміна 5 (закоментована).Вибір правильного айді якщо є мейн,якщо нема data[0].id
      const awUploadQuery = role === 'ROLE_ADMIN'
        ? `${urlApi_2}?worker.id=${data.id}`
        : `${urlApi_2}?worker.id=${data.id}&account.user.id=${userData.id}`
      const responseAccount = await AxiosInstance.get(awUploadQuery, header)

      // const responseAccount = await AxiosInstance.get(`${urlApi_2}?worker.id=${data.id}`, header)
      // const accountId = responseAccount.data[0].id

      const mainAW = responseAccount.data.find(el => el.mainForUsers?.includes(userData.id)) || responseAccount.data[0]
      if (!mainAW) {
        toast.success('Немає контрагента для завантаження документів')
        return
      }


      const accountId = mainAW.id


      // Створити URL для відправки файлу
      const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects?accountWorker=' + accountId

      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('name', file.name)
        formData.append('accountWorker', accountId)


        // const timestamp = dayjs().toISOString() // ISO-формат
        // formData.append('uploadTimestamp', timestamp)

        // Відправити файл
        const responseFile = await AxiosInstance.post(url, formData, header)
      }

      // Отримати оновлені дані після завантаження файлу
      // const responseUpdatedData = await AxiosInstance.get(
      //   `${urlApi_2}?worker.id=${data.id}`,
      //   header,
      // )
      const awUpdatedQuery = role === 'ROLE_ADMIN'
        ? `${urlApi_2}?worker.id=${data.id}`
        : `${urlApi_2}?worker.id=${data.id}&account.user.id=${userData.id}`
      const responseUpdatedData = await AxiosInstance.get(awUpdatedQuery, header)


      // setArrFile([...responseUpdatedData.data[0].media])
      //зміна 6
      const mainUpdated = responseUpdatedData.data.find(el => el.mainForUsers?.includes(userData.id)) || responseUpdatedData.data[0]
      setArrFile([...(mainUpdated?.media || [])])

    } catch (error) {
      console.error('Сталася помилка під час обробки запиту', error)
    }
  }

  const deleteFile = async (id) => {
    try {
      await confirmAlert({
        title: 'Ви впевнені що хочите видалити цей пункт ?',
        message: 'Are you sure to do this.',
        buttons: [
          {
            label: 'Так',
            onClick: async () => {
              // Видалення файлу
              await AxiosInstance.delete(`${urlMedia}/${id}`, header)
              popup.toastifySuccess(popupTextDeleteSuccess)

              const awDeleteQuery = role === 'ROLE_ADMIN'
                ? `${urlApi_2}?worker.id=${data.id}`
                : `${urlApi_2}?worker.id=${data.id}&account.user.id=${userData.id}`
              const response = await AxiosInstance.get(awDeleteQuery, header)

              // Отримання оновлених даних після видалення файлу

              // const response = await AxiosInstance.get(`${urlApi_2}?worker.id=${data.id}`, header)
              //зміна 7 Отримання оновлених даних з логікою мейн після видалення
              // setArrFile([...response.data[0].media])
              const mainAfterDelete = response.data.find(el => el.mainForUsers?.includes(userData.id)) || response.data[0]
              setArrFile([...(mainAfterDelete?.media || [])])

            },
          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    }
  }

  // додаємо аватар
  const handleAddPhoto = async () => {
    try {
      // Створити URL для відправки файлу з фото
      const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects'

      if (photo) {
        const formData = new FormData()
        formData.append('file', photo)
        formData.append('name', photo.name)

        // Відправити файл з фото
        const responsePhoto = await AxiosInstance.post(url, formData, header)

        // закидуєм на воркер створене фото
        if (responsePhoto.status === 201) {
          // Іd фото для можливого подільшого видалення після завантаження нового
          setdeleteOldPhotoId(responsePhoto.data.id)

          const data_response = {
            photo: `/api/media_objects/${responsePhoto.data.id}`,
          }

          const responseAddPhoto = AxiosInstance.patch(
            // `${urlApi}/${data.id}`,
            `${urlApi}/${workerId}`,
            data_response,
            header,
          )

          // видалення старого фото
          // if (data.photo.id) {
          if (deleteOldPhotoId) {
            // const deleteOldPhoto = AxiosInstance.delete(`${url}/${data.photo.id}`, header)
            const deleteOldPhoto = AxiosInstance.delete(`${url}/${deleteOldPhotoId}`, header)
          }
        }
      }

      // Отримати оновлені дані після завантаження файлу
      // const response1 = await AxiosInstance.get(`${urlApi}/${data.id}`, header)
      const response1 = await AxiosInstance.get(`${urlApi}/${workerId}`, header)

      setDataState(response1.data)
    } catch (error) {
      console.error('Сталася помилка під час обробки запиту', error)
    }
  }

  const handleChange = (e, key, state, setState) => {
    setState({
      ...state,
      [key]: e.target.value,
    })
  }

  useEffect(() => {
    // console.log('ipn', ipn);
  }, [ipn])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleIpnChange(ipn)
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [ipn])

  // пошук по іпн
  const handleIpnChange = async (value) => {
    // якщо нічого не введено перерви
    if (!value) {
      setDataState({ codeIpn: value })
      return
    }

    // Перевірка довжини введеного значення (не більше 10 цифр)
    if (value.length > 10) {
      // console.log('Введено занадто багато цифр');
      popup.toastifyWarning('Введено занадто багато цифр необхідно 10 цифр')
      return;
    }

    // Перевірка, чи введене значення складається лише з цифр
    if (!/^\d+$/.test(value)) {
      popup.toastifyWarning('Введено не числові значення необхідно 10 цифр')
      return;
    }

    try {
      const response = await AxiosInstance.get(`${urlApi}?codeIpn=${value}`)
      const dataById = response.data['hydra:member']?.[0]
      // console.log('якщо ід введено запит', dataById)

      if (dataById?.codeIpn === value) {
        // якщо є відповідні дані, встановлюємо їх
        setDataState(dataById)
        console.log('є такий')
      } else {
        // якщо немає відповідних даних, встановлюємо { codeIpn: value }
        setDataState({ codeIpn: value })
        setCombinedDate({ day: '', month: '', year: '' })
        setCombinedSeries({ series: '', number: '' })
        console.log('нема такого')
      }
    } catch (error) {
      console.error('Помилка при отриманні даних:', error)
    }
  }




  // логіка для отримання професій працівника

  const workerProfessionsList = async () => {
    // const response = await AxiosInstance.get(`/worker_professions?worker.id=${dataState.id}`)
    // setWorkerProfessions(response.data['hydra:member'])
    //
    try {

      const response = await AxiosInstance.get(`/worker_proffessions?worker.id=${dataState.id}`);
      const professions = response.data['hydra:member'];


      //сортування для впевненості,якщо не буде вертати з апі в порядку зростання id
      const sortedProfessions = professions?.map((item) => {
        //щоб нові доки були вкінці
        const sortedDocs = [...item.workerProffesionDocs].sort((a, b) => a.id - b.id);
        //щоб нові доки були спочатку
        // const sortedDocs = [...item.workerProffesionDocs].sort((a, b) => b.id - a.id);


        return {
          ...item,
          workerProffesionDocs: sortedDocs,
        };

      })


      console.log('professions', professions)
      // const detailedProfessions = await Promise.all(
      //   professions.map(async (item) => {

      //     let professionData = null;
      //     let docsData = []
      //     if (item.proffesion && typeof item.proffesion === "string") {
      //       const res = await AxiosInstance.get(`worker_proffession_lists?workerProffessions.id=${item.id}`);
      //       professionData = res.data['hydra:member'][0];
      //     }
      //     if (item.workerProffesionDocs && item.workerProffesionDocs.length > 0

      //     ) {
      //       const res = await AxiosInstance.get(`worker_proffession_docs?workerProffesion.id=${item.id}`);
      //       docsData = res.data['hydra:member'];
      //     }


      //     return {
      //       ...item,
      //       workerProfessionsList: professionData || item.proffesion,
      //       workerProffesionDocs: docsData || item.workerProffesionDocs
      //     };
      //   })
      // );


      // setWorkerProfessions(detailedProfessions);

      setWorkerProfessions(sortedProfessions)
      //  setWorkerProfessions(professions)
    } catch (error) {
      console.error("Помилка при завантаженні професій:", error);
    }
  }



  // const loadJobOptions = async () => {
  //   try {
  //     const response = await AxiosInstance.get(`/worker_profession_lists`);
  //     const options = response.data['hydra:member']
  //       .filter(opt => {

  //         return !workerProfessions.some(p => {
  //           if (p.proffesion && typeof p.proffesion === 'object') {
  //             return p.proffesion.id === opt.id;
  //           }
  //           // Якщо професія — рядок типу "/api/worker_profession_lists/5"
  //           if (typeof p.proffesion === 'string') {
  //             const profId = p.proffesion.split('/').pop();
  //             return parseInt(profId) === opt.id;
  //           }
  //           return false;
  //         }
  //         )

  //       })

  //       .map((job) => ({
  //         label: job.name,
  //         value: job.id,
  //       }));

  //     setJobList(options);
  //     return options;


  //   } catch (error) {
  //     console.error('Помилка завантаження професій:', error);
  //     setJobList([]);
  //     return [];
  //   }
  // };

  const loadJobOptions = async () => {
    try {
      const response = await AxiosInstance.get(`/worker_proffession_lists`);
      const allOptions = response.data['hydra:member'];

      // console.log('allOptions', allOptions)

      // const filtered = allOptions.filter(opt => {
      //   return !workerProfessions.some(p => {
      //     if (p.workerProffessionList && typeof p.workerProffessionList === 'object') {
      //       return p.workerProffessionList.id === opt.id;
      //     }
      //     return false;
      //   });
      // });
      // console.log('filtered', filtered)

      // const options = filtered.map(job => ({
      //   label: job.name,
      //   value: job.id,
      // }));

      // setJobList(options);
      // return options;


      //
      const options = allOptions.map(job => ({
        label: job.name,
        value: job.id,
      }));
      setJobList(options)
      return options

    } catch (error) {
      console.error('Помилка завантаження професій:', error);
      setJobList([]);
      return [];
    }
  };




  useEffect(() => {
    // const fetchData = async () => {
    //   await workerProfessionsList();
    //   await loadJobOptions();
    // };
    // fetchData()

    workerProfessionsList();
    loadJobOptions();
  }, [])

  // useEffect(() => {
  //   if (workerProfessions.length > 0) {
  //     loadJobOptions()
  //   }

  // }, [workerProfessions.length])



  //додавання профессіі

  const addProfession = async (id) => {
    console.log('CLICK', id)
    const exists = workerProfessions.some(
      (prof) => prof.workerProffessionList.id === id
    );

    if (exists) {
      toast.warn("Така робота вже додана!");
      return;
    }
    try {
      const response = await AxiosInstance.post(`/worker_proffessions`, {
        workerProffessionList: `/api/worker_proffession_lists/${id}`,
        worker: `/api/workers/${dataState.id}`,
        status: "new"
        // type: "main",
      });

      console.log('response.data', response.data)
      // workerProfessionsList()
      setWorkerProfessions((prev) => [response.data, ...prev,]);
      toast.success('Професія успішно додана')
      // setProfessionsList((prev) => [...prev, response.data]);
      // setSelectedJob(null);
    } catch (error) {
      console.error("Помилка:", error);
    }
  };



  //обробник для додавання файлу
  const handleFileChangeForProfession = (event, professionId) => {
    const file = event.target.files[0];
    if (!file) return;

    // Перевірка формату PDF
    const isPdf =
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf');

    if (!isPdf) {
      toast.error('Дозволено завантажувати лише PDF-файли', {
        // position: 'top-center',
      });
      // Очистимо input, щоб користувач міг одразу вибрати інший файл
      event.target.value = '';
      return;
    }


    setFilesByProfession(prev => ({
      ...prev,
      [professionId]: file,
    }));
  };


  const addFileForProfession = async (professionId, event) => {
    console.log('CLICKK')

    try {
      // const file = e.target.files[0];
      const file = filesByProfession[professionId];
      if (!file) return;

      // if (file.type !== 'application/pdf') {
      //   toast.error(`Цей файл ${file.type}`)
      //   toast.error('Дозволено завантажувати лише PDF-файли', {

      //   });
      //   return;
      // }

      const mediaUrl = '/media_objects';
      const docsUrl = '/worker_proffesion_docs';

      //  Створюєм media object
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name);

      const responseMedia = await AxiosInstance.post(mediaUrl, formData, header);

      if (responseMedia.status === 201) {
        const mediaId = responseMedia.data.id;

        console.log('responseMedia', responseMedia)
        const docData = {
          workerProffesion: `/api/worker_proffessions/${professionId}`,
          // name: file.name,
          media: `/api/media_objects/${mediaId}`,
          status: 'new',
          // type: file.type,
          // userConfirm: null,
          // dateConfirm: null,
          dateEntered: new Date().toISOString(),
        };

        await AxiosInstance.post(docsUrl, docData, header);

        // 🧹 Очистимо стан
        setFilesByProfession(prev => {
          const newState = { ...prev };
          delete newState[professionId];
          return newState;
        });

        // // 🧹 Очистимо input
        // if (event?.target) {
        //   const input = event.target
        //     .closest(`.${css.infoBlock}`)
        //     ?.querySelector(`#file-${professionId}`);
        //   if (input) input.value = '';
        // }
        // 🧹 очищення самого input
        if (fileInputs.current[professionId]) {
          fileInputs.current[professionId].value = '';
        }


        // const updatedWorker = await AxiosInstance.get(`${urlApi}/${workerId}`, header);
        // setDataState(updatedWorker.data);
        workerProfessionsList()
        toast.success('Файл успішно завантажено');
      }
    } catch (error) {
      console.error('Помилка при завантаженны файлу:', error);
    }
  };




  // console.log('jobList', jobList)
  // console.log('workerProfessions', workerProfessions)
  // console.log('selectedJob', selectedJob)
  // console.log('filesByProfession', filesByProfession)
  // console.log('lodJobOptions', loadJobOptions)
  // console.log('selectedOption', selectedOption)

  //БЛОК ЗМІНИ СТАТУСА ДОКУМЕНТА ДЛЯ АДМІНА

  //зміна статуса на підтверджено verified
  async function adminDocConfirmToSuccess(id) {
    try {
      await confirmAlert({
        title: 'Увага',
        message: 'Ви впевнені що хочете підтвердити документ ?',
        buttons: [
          {
            label: 'Так',
            onClick: async () => changeStatusToSuccess(id)
          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    }

  }

  async function changeStatusToSuccess(id) {
    const docData = {
      status: 'verified',
      dateConfirm: new Date().toISOString(),
      userConfirmDescription: coment[id] || ''
    }

    try {
      const response = await AxiosInstance.put(`${docsUrl}/${id}`, docData, header);
      toast.success('Документ підтверджено')
      workerProfessionsList()
      setComent(prev => {
        const newComent = { ...prev };
        delete newComent[id];
        return newComent;
      })
      return response.data;
    } catch (error) {
      console.error('Помилка при зміні статуса:', error);
      throw error;
    }
  }

  //зміна статуса на rejected
  async function adminDocConfirmToRejected(id) {

    try {
      await confirmAlert({
        title: 'Увага',
        message: 'Ви впевнені що хочете повернути документ на доопрацювання ?',
        buttons: [
          {
            label: 'Так',
            onClick: async () => changeStatusToRejected(id)
          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    }

  }

  async function changeStatusToRejected(id) {
    const docData = {
      status: 'rejected',
      userConfirmDescription: coment[id] || ''
    }

    try {
      const response = await AxiosInstance.put(`${docsUrl}/${id}`, docData, header);
      toast.success('Документ повернуто на доопрацювання')
      workerProfessionsList()
      setComent(prev => {
        const newComent = { ...prev };
        delete newComent[id];
        return newComent;
      })
      return response.data;
    } catch (error) {
      console.error('Помилка при зміні статуса:', error);
      throw error;
    }
  }

  //БЛОК ЗМІНИ СТАТУСА ДЛЯ ПАРТНЕРА
  //зміна статуса на send-to-verify +

  async function partnerDocConfirmToSendToVerify(id) {
    try {
      await confirmAlert({
        title: 'Увага',
        message: 'Ви впевнені що хочете відправити документ на перевірку ?',
        buttons: [
          {
            label: 'Так',
            onClick: async () => changeStatusToSendToVerify(id)
          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    }

  }

  async function changeStatusToSendToVerify(id) {
    const docData = {
      status: 'send-to-verify'
    }

    try {
      const response = await AxiosInstance.put(`${docsUrl}/${id}`, docData, header);
      toast.success('Документ відправлено на перевірку')
      workerProfessionsList()
      return response.data;
    } catch (error) {
      console.error('Помилка при зміні статуса:', error);
      throw error;
    }
  }

  //зміна стану для коменту

  function handleComentChange(id, value) {
    setComent(
      prev => {
        return ({ ...prev, [id]: value })
      }
    )
  }

  const getStatusText = (status) => {
    switch (status) {
      case 'new':
        return 'Новий'
      case 'verified':
        return 'Підтверджено'
      case 'send-to-verify':
        return 'Відправлено на перевірку'
      case 'rejected':
        return 'Відхилено'
      default:
        return status
    }
  }

  //Перевірка частини даних для можливості відправити на перевірку
  // const canSendToVerify =
  //   ipn &&
  //   dataState?.position &&
  //   (combinedDate.day && combinedDate.day !== '00') &&
  //   (combinedDate.month && combinedDate.month !== '00') &&
  //   (combinedDate.year && combinedDate.year !== '1900') &&
  //   dataState?.phone &&
  //   arrFile.length > 0
  const canSendToVerify =
    savedDataState?.codeIpn &&
    savedDataState?.position &&
    savedDataState?.dateOfBirth &&
    savedDataState?.phone &&
    arrFile.length > 0





  // console.log('jobList', jobList)
  // console.log('workerProfessions', workerProfessions)
  // console.log('selectedJob', selectedJob)
  // console.log('filesByProfession', filesByProfession)
  // console.log('lodJobOptions', loadJobOptions)
  // console.log('dataSate', dataState)
  // console.log('coment', coment)
  // console.log('arrFile', arrFile)
  // console.log('data', data)
  // console.log('savedDataState', savedDataState)




  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      {/* форма існуючого працівника */}

      <CForm onSubmit={handleSubmit} className="mb-3">
        <div className="d-flex gap-5">
          <div
          // style={{ maxWidth: '500px', marginRight: '100px' }}
          >
            <div className="mb-3" style={{ maxWidth: '390px' }}>
              <CFormLabel htmlFor="exampleFormControlInput5">
                {dataState?.id ? <p>Працівник з таким ІПН існує</p> : <p>ІПН працівника</p>}
              </CFormLabel>
              <CFormInput
                type="text"
                id="exampleFormControlInput5"

                value={ipn}
                disabled={data}

                onChange={(e) => setIpn(e.target.value)}
                // onChange={handleIpnChange}
                autoComplete="off"
                required
              />
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
              <AsyncSelect
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions
                onInputChange={(inputValue) => setInputValue(inputValue)}
                value={selectedOption}
                onChange={handleChangePartner}
                className="flex-grow-1"
              />
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Посада</CFormLabel>
              <CFormInput
                type="text"
                id="exampleFormControlInput1"
                value={dataState?.position ? dataState.position : ''}
                disabled={
                  (data && role !== 'ROLE_ADMIN') || (dataState?.id && role !== 'ROLE_ADMIN')
                }
                autoComplete="off"
                onChange={(e) => handleChange(e, 'position', dataState, setDataState)}
                required
              />
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">ПІБ</CFormLabel>
              <CFormInput
                type="text"
                id="exampleFormControlInput1"
                value={dataState?.fullName ? dataState.fullName : ''}
                // disabled={data &&  role !== 'ROLE_ADMIN'}
                disabled={
                  (data && role !== 'ROLE_ADMIN') || (dataState?.id && role !== 'ROLE_ADMIN')
                }
                autoComplete="off"
                onChange={(e) => handleChange(e, 'fullName', dataState, setDataState)}
                required
              />
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Дата та рік народження</CFormLabel>

              <div className="d-flex align-items-center">
                <CFormInput
                  style={{ marginRight: '10px', width: '50px' }}
                  type="text"
                  id="yearOfBirthInput"
                  value={combinedDate.day}
                  // disabled={data && role !== 'ROLE_ADMIN'}
                  autoComplete="off"
                  onChange={(e) => handleChange(e, 'day', combinedDate, setCombinedDate)}
                  required
                />
                <CFormInput
                  style={{ marginRight: '10px', width: '50px' }}
                  type="text"
                  id="yearOfBirthInput"
                  value={combinedDate.month}
                  // disabled={data && role !== 'ROLE_ADMIN'}
                  autoComplete="off"
                  onChange={(e) => handleChange(e, 'month', combinedDate, setCombinedDate)}
                  required
                />
                <CFormInput
                  style={{ marginRight: '10px', width: '60px' }}
                  type="text"
                  id="yearOfBirthInput"
                  value={combinedDate.year}
                  // disabled={data && role !== 'ROLE_ADMIN'}
                  autoComplete="off"
                  onChange={(e) => handleChange(e, 'year', combinedDate, setCombinedDate)}
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">
                Серія та номер паспорта (для ID картки лише номер)
              </CFormLabel>

              <div className="d-flex align-items-center">
                <CFormInput
                  style={{ marginRight: '10px', width: '50px' }}
                  type="text"
                  id="series"
                  value={combinedSeries.series}
                  // disabled={data && role !== 'ROLE_ADMIN'}
                  autoComplete="off"
                  onChange={(e) => handleChange(e, 'series', combinedSeries, setCombinedSeries)}
                // required
                />
                <CFormInput
                  style={{ marginRight: '10px', width: '100px' }}
                  type="text"
                  id="number"
                  value={combinedSeries.number}
                  // disabled={data && role !== 'ROLE_ADMIN'}
                  autoComplete="off"
                  onChange={(e) => handleChange(e, 'number', combinedSeries, setCombinedSeries)}
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Телефон</CFormLabel>
              <CFormInput
                type="text"
                id="exampleFormControlInput1"
                value={dataState?.phone ? dataState.phone : ''}
                // disabled={data && role !== 'ROLE_ADMIN'}
                autoComplete="off"
                onChange={(e) => handleChange(e, 'phone', dataState, setDataState)}
                required
              />
            </div>

            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Коментар</CFormLabel>
              <CFormInput
                type="text"
                id="exampleFormControlInput1"
                value={dataState?.description ? dataState.description : ''}
                // disabled={role !== 'ROLE_ADMIN'}
                autoComplete="off"
                onChange={(e) => handleChange(e, 'description', dataState, setDataState)}
              />
            </div>

            {/* {role === 'ROLE_ADMIN' ? ( */}
            <div className="mb-3 d-flex gap-5">
              <CButton type="submit" color="secondary">
                {dataState?.id ? 'Оновити дані працівника' : 'Додати працівника'}
              </CButton>
              {/* тут формується посвідчення */}
              <CButton color='secondary' onClick={() => setShowPopup(true)}>
                Сформувати посвідчення
              </CButton>
            </div>
            {/* ) : (
              ''
            )} */}
          </div>

          {/*Правий блок */}
          {dataState?.id || data ? (
            <div className={css.rightBlock}
            // style={{ maxWidth: '300px' }}
            >

              {/*вкладений лівий*/}
              <div>
                <div
                  // className="mb-3"
                  className={`${css.overlayWrapper} mb-3`}>
                  {workerPhoto ? (
                    <img
                      // src={process.env.REACT_APP_SERVER_URL + dataState.photo.contentUrl}
                      src={process.env.REACT_APP_SERVER_URL + workerPhoto}
                      width="100%"
                      height="100%"
                      alt="фото"
                      style={{ objectFit: 'cover' }}
                    />
                  ) : (
                    <BsFillPersonFill size={250} />
                  )}

                  <div className={css.overlay}>
                    <p>
                      - Особа повинна дивитися в камеру. <br />
                      - Особа не повинна носити маски, головні убори чи пов’язки на очах. <br />
                      - Особа не повинна піднімати голову або нахилятися. <br />
                      - Особа не повинна носити густий макіяж. <br />
                      - Особа не повинна мати закриті очі. <br />
                      - Переконайтеся, щоб обидва плечі особи були на фото. <br />
                      - Перек онайтеся, щоб на фото не було два обличчя. <br />
                    </p>
                  </div>

                </div>

                {/* Додавання фото */}
                <div className="mb-3">
                  <CFormInput
                    type="file"
                    id="exampleFormControlFile1"
                    onChange={handlePhotoChange}
                    multiple
                  />
                </div>

                <div>
                  <CButton onClick={handleAddPhoto} color="success" disabled={!photo ? true : false}>
                    Додати фото
                  </CButton>
                </div>
              </div>

              <div className={css.rightBlock__info}>
                {/* <div className={css.infoBlock}>
                  <div className={css.infoBlock__top}>
                    <div className="mb-3" style={{ width: '200px' }}>
                      <CFormLabel htmlFor="exampleFormControlInput1" style={{ color: 'red' }}>Cписок професій</CFormLabel>
                      <AsyncSelect
                        cacheOptions
                        loadOptions={loadOptions}
                        defaultOptions
                        className="flex-grow-1"
                      />
                    </div>
                    <div className='mb-3'>
                      <CFormLabel htmlFor="exampleFormControlFile1">Виберіть файли</CFormLabel>
                      <CFormInput
                        type="file"
                        id="exampleFormControlFile1"
                        multiple
                      />

                    </div>
                  </div>

                  <div className={css.infoBlock__bottom}>
                    <a>Документ</a>
                    <div className={css.partnerConfirm}>
                      <CButton color='info'>На превірку</CButton>
                      <CButton color='success'>Підтверджено</CButton>
                    </div>
                    <div className={css.adminConfirm}>
                      <CButton color='info'>Підтвердити</CButton>
                      <CButton color='success'>Підтверджено</CButton>
                      <CButton color='danger'>Повернути на доопрацювання</CButton>
                    </div>
                  </div>

                </div> */}
                <div className={css.infoBlocks}>

                  {workerProfessions?.map((item) => {
                    // console.log('item', item)
                    //Закоментував поінт по останньому айтему
                    // const point = item.workerProffesionDocs[item.workerProffesionDocs.length - 1]
                    const point = item.workerProffesionDocs?.reduce((max, doc) => {
                      return doc.id > max.id ? doc : max
                    }, item.workerProffesionDocs[0])

                    // console.log('point', point)
                    return <div
                      // key={item.workerProffessionList.id}
                      key={item.id}
                      className={css.infoBlock}>

                      <div className={css.infoBlock__top}>
                        <div className="mb-3" style={{ width: "200px" }}>
                          <CFormLabel htmlFor={`prof-${item.workerProffessionList.id}`}>
                            Cписок професій
                          </CFormLabel>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            isDisabled={true}
                            defaultValue={{
                              label: item.workerProffessionList.name,
                              value: item.workerProffessionList.id
                            }}
                            loadOptions={loadJobOptions}
                            className="flex-grow-1"
                          />
                        </div>

                        <div className="mb-3">
                          <CFormLabel htmlFor={`file-${item.workerProffessionList.id}`}>Виберіть файл</CFormLabel>
                          <CFormInput
                            type="file"
                            id={`file-${item.workerProffessionList.id}`}
                            //додав для очищення
                            // key={filesByProfession[item.id] ? `file-${item.id}-filled` : `file-${item.id}-empty`}
                            //?
                            ref={(el) => (fileInputs.current[item.id] = el)}
                            //
                            onChange={(e) => handleFileChangeForProfession(e, item.id)}
                          />
                        </div>
                        {role === 'ROLE_ADMIN' && <div className="mb-3">
                          <CButton color="danger" variant="outline"
                            onClick={() => deleteProffesion(item.id)}
                          >
                            <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
                          </CButton>
                        </div>}
                      </div>
                      {/* ${point?.media.contentUrl} */}
                      {/* виніс попереднє ${item.workerProffesionDocs[item.workerProffesionDocs.length - 1].media.contentUrl} */}
                      <div className={css.infoBlock__main}>
                        <CButton color="secondary" onClick={(e) => addFileForProfession(item.id, e)}
                        >Зберегти дані працівника</CButton>
                        {item.workerProffesionDocs?.length > 0 ? <a href={`${process.env.REACT_APP_SERVER_URL}${point?.media?.contentUrl}`}>Документ</a> : ''}
                        {/* {(point.status === 'verified' && point.dateConfirm) ? `Підтверджено ${dayjs(point.dateConfirm).format('YYYY-MM-DD')}` : ''} */}
                        {(item.workerProffesionDocs?.length > 0 && role === 'ROLE_ADMIN') &&
                          <span style={{ marginLeft: "10px" }}>
                            <span style={{ fontWeight: '600' }}>Статус:</span> {getStatusText(point?.status)}
                          </span>}
                      </div>


                      <div className={css.infoBlock__bottom}>
                        {/* Блок партнера для відправлення на перевірку */}

                        {
                          (
                            role === 'ROLE_PARTNER' &&
                            point) && <div className={css.partnerConfirm}>
                            {
                              (point?.status === 'new' || point?.status === 'rejected') &&
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <CButton
                                  color='info'
                                  disabled={!canSendToVerify}
                                  onClick={() => partnerDocConfirmToSendToVerify(point.id)}
                                >На перевірку</CButton>
                                <CButton
                                  color='secondary'
                                  variant='outline'
                                  size='sm'
                                  style={{ borderRadius: '50%', width: '24px', height: '24px', padding: 0, lineHeight: 1, fontWeight: 'bold', flexShrink: 0 }}
                                  onClick={() => setShowVerifyHelpModal(true)}
                                  title='Умови активації'
                                >?</CButton>
                              </div>
                            }

                            {point?.status === 'verified' && <CButton color='success'>
                              Підтверджено{' '}<br />
                              {(point.status === 'verified' && point.dateConfirm) ? `${dayjs(point.dateConfirm).format('YYYY-MM-DD')}` : ''}
                            </CButton>}


                            {(point?.status === 'rejected' || point?.status === 'verified') && <div
                              style={{ color: point.status === 'rejected' ? 'red' : 'green' }}
                            >
                              {/* {point.userConfirmDescription && <span style={{ color: 'black' }}>Коментар:{' '}</span>} */}

                              {point?.userConfirmDescription ? point.userConfirmDescription : ''}
                            </div>}

                            {point?.status === 'send-to-verify' && <CButton color='success'>На перевірці</CButton>}
                          </div>
                        }


                        {(role === 'ROLE_ADMIN' && point) && <div className={css.adminConfirm}>
                          {point?.status === 'send-to-verify' && <CButton
                            onClick={() => adminDocConfirmToSuccess(point.id)}
                            color='info'>Підтвердити</CButton>}
                          {point?.status === 'send-to-verify' && <CButton
                            onClick={() => adminDocConfirmToRejected(point.id)}
                            color='danger'>Повернути на доопрацювання</CButton>}
                          {point?.status === 'send-to-verify' &&
                            <CFormTextarea
                              onChange={(e) => handleComentChange(point.id, e.target.value)}
                              color='danger'></CFormTextarea>}
                          {point?.status === 'verified' && <CButton color='success'>
                            {/* Підтверджено */}
                            Підтверджено{' '}<br />
                            {(point.status === 'verified' && point.dateConfirm) ? dayjs(point.dateConfirm).format('YYYY-MM-DD') : ''}
                          </CButton>}
                          {point?.status === 'rejected' && <CButton color='warning'>Повернуто на доопрацювання</CButton>}
                        </div>}
                      </div>


                    </div>
                  }

                  )}
                  {/* блоки для додавання */}
                  <h3>Додати професію</h3>
                  {blocks.map((block, index) => (
                    <div key={index} className={css.infoBlock}>
                      <div className={css.infoBlock__top}>
                        <div style={{ width: "200px" }}>
                          <CFormLabel htmlFor={`prof-${index}`} style={{ color: "red" }}>
                            Cписок професій
                          </CFormLabel>
                          <AsyncSelect
                            cacheOptions
                            loadOptions={loadJobOptions}
                            defaultOptions
                            className="flex-grow-1"
                            onChange={(option) => setSelectedJob(option)}
                          />

                        </div>
                        <CButton color='secondary'
                          onClick={() => addProfession(selectedJob.value)}
                        >+</CButton>
                      </div>

                      <div className={css.infoBlock__main}>
                      </div>

                      {/* <div className={css.infoBlock__bottom}>
                        <div className={css.confirmPartner}>
                          <CButton>Відправити на перевірку</CButton>
                        </div>
                        <div className={css.confirmAdmin}>
                          <CButton>Підтвердити</CButton>
                          <CButton color='danger'>Доопрацювати</CButton>
                        </div>
                      </div> */}
                    </div>
                  ))}

                </div>


                {/* <div className='mb-5'>
                  <CButton color="secondary" onClick={addNewBlock}>
                    ➕ Додати блок
                  </CButton>
                </div> */}
              </div>
            </div>

          ) : (
            ''
          )}
        </div>



        {dataState?.id || data ? (
          <div>
            <div className="mb-3" style={{ maxWidth: '400px' }}>
              <CFormLabel htmlFor="exampleFormControlFile1">Виберіть файли</CFormLabel>
              <CFormInput
                type="file"
                id="exampleFormControlFile1"
                onChange={handleFileChange}
                multiple
              />
            </div>

            <div>
              <CButton
                onClick={handleSubmitAddFile}
                color="success"
                disabled={!file ? true : false}
              >
                Завантажити документи
              </CButton>
              <Link to={urlRouter} className="ms-3">
                <CButton type="submit" color="secondary">
                  Відміна
                </CButton>
              </Link>
            </div>

            <div className={css.wrapperButton}>
              <p>Наявні документи</p>
              {arrFile.map((el, index) => (
                <div className={css.file_block} key={index}>
                  {el.contentUrl.endsWith('.jpg') ? (
                    // <img
                    //   src={process.env.REACT_APP_SERVER_URL + el.contentUrl}
                    //   width="50px"
                    //   alt={`Image ${index}`}
                    // />

                    <a
                      href={process.env.REACT_APP_SERVER_URL + el.contentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {el.contentUrl}
                    </a>
                  ) : (
                    <a
                      href={process.env.REACT_APP_SERVER_URL + el.contentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {el.contentUrl}
                    </a>
                  )}
                  {/* <h5>Блок дати</h5> */}
                  {(el.uploadTimestamp && dayjs(el.uploadTimestamp).isValid()) ? dayjs(el.uploadTimestamp).format('DD.MM.YYYY HH:mm') : ''}
                  <CButton color="danger" variant="outline" onClick={() => deleteFile(el.id)}>
                    <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
                  </CButton>
                </div>
              ))}
            </div>
          </div>
        ) : (
          ''
        )}
      </CForm >
      {showPopup && (
        // <WorkerModal onClose={() => setShowPopup(false)} dataState={dataState} workerProfessions={workerProfessions} selectedOption={selectedOption} />
        <WorkerModalV1 onClose={() => setShowPopup(false)} dataState={dataState} workerProfessions={workerProfessions} selectedOption={selectedOption} />

      )
      }

      <CModal visible={showVerifyHelpModal} onClose={() => setShowVerifyHelpModal(false)}>
        <CModalBody>
          <h5>Кнопка "На перевірку"</h5>
          <p>Якщо ви бачите задизейблену кнопку "На перевірку" — заповніть поля працівника і завантажте документ внизу сторінки (якщо ще не завантажений):</p>
          <ul>
            <li>ІПН</li>
            <li>Посада</li>
            <li>Дата народження</li>
            <li>Телефон</li>
            <li>Документ</li>
          </ul>
          <p>та натисніть <strong>"Оновити дані працівника"</strong>. Після цього спробуйте натиснути <strong>"Відправити на перевірку"</strong> знову.</p>
        </CModalBody>
        <CModalFooter>
          <CButton color='secondary' onClick={() => setShowVerifyHelpModal(false)}>Закрити</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default WorkersForm
